
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import { APP_CONFIG } from '../config';

// This file centralizes Google Analytics tracking logic.

// Extend the Window interface to include the gtag function for TypeScript.
declare global {
    interface Window {
      gtag: (
        command: 'config' | 'event',
        targetId: string,
        config?: Record<string, unknown>
      ) => void;
    }
}
  
const GA_TRACKING_ID = APP_CONFIG.GA_TRACKING_ID;

/**
 * Tracks a page view event in Google Analytics.
 * This should be called whenever the user navigates to a new "page" in the SPA.
 * @param {string} path - The path of the page (e.g., '/canvas', '/my-styles').
 * @param {string} title - The title of the page.
 */
export const trackPageView = (path: string, title: string) => {
    if (typeof window.gtag === 'function') {
        window.gtag('config', GA_TRACKING_ID, {
            page_path: path,
            page_title: title,
        });
        console.log(`GA: Page View tracked for ${path}`);
    } else {
        console.warn('Google Analytics gtag function not found.');
    }
};

/**
 * Tracks a custom event in Google Analytics.
 * Use this to measure specific user interactions like button clicks, form submissions, etc.
 * @param {string} eventName - The name of the event (e.g., 'save_outfit', 'generate_lookbook').
 * @param {Record<string, any>} [eventParams] - Optional parameters providing more context about the event.
 */
export const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
    if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, eventParams);
        console.log(`GA: Event tracked: ${eventName}`, eventParams || '');
    } else {
        console.warn('Google Analytics gtag function not found.');
    }
};
